__turbopack_context__.v({
  "article_description": "Articles-module-scss-module__Nx7aoq__article_description",
  "article_headline": "Articles-module-scss-module__Nx7aoq__article_headline",
  "article_image": "Articles-module-scss-module__Nx7aoq__article_image",
  "article_image_link": "Articles-module-scss-module__Nx7aoq__article_image_link",
  "article_over_title": "Articles-module-scss-module__Nx7aoq__article_over_title",
  "article_thumbnail": "Articles-module-scss-module__Nx7aoq__article_thumbnail",
  "articles": "Articles-module-scss-module__Nx7aoq__articles",
  "articles_title": "Articles-module-scss-module__Nx7aoq__articles_title",
  "splide__arrow": "Articles-module-scss-module__Nx7aoq__splide__arrow",
});
